module.exports = __webpack_public_path__ + "static/media/inventory_management.344aec29.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/inventory_management.svg
// module id = 395
// module chunks = 0